import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloPersonne } from '@/models/alo/AloPersonne'
import { AxiosPromise } from 'axios'
import { AloUserIdentity } from '@/models/alo/AloUserIdentity'
import { AloForgottenPass } from '@/models/alo/AloForgottenPass'

export default {
  authenticate(user: AloUserIdentity): AxiosPromise<AlrContainer<AloPersonne>>  {
    return apiHelpers.apiCall({ 
        url:'/webapi/api/admin/Authenticate', 
        method:'POST', 
        data: user,
        transformResponse: [function (data: string) {                              
          return JSON.parse(data) as AlrContainer<AloPersonne>
        }]
     })
  },
  
  getAuthenticatedUser(): AxiosPromise<AlrContainer<AloPersonne>>  {
    return apiHelpers.apiCall({ 
      url: '/webapi/api/admin/Authenticate', 
      method: 'GET',
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<AloPersonne>
      }] 
    })
  },

  logout(): AxiosPromise<AlrContainer<string>>  {
    return apiHelpers.apiCall({ 
      url: '/webapi/api/admin/Authenticate', 
      method: 'DELETE',
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<string>
      }] 
    })
  },

  forgetPassword(data:AloForgottenPass): AxiosPromise<AlrContainer<string>>  {
    return apiHelpers.apiCall({ 
      url: '/webapi/api/admin/Authenticate/forgotten', 
      method: 'POST',
      data,
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<string>
      }] 
    })
  },

  changePassword(data:AloForgottenPass): AxiosPromise<AlrContainer<string>>  {
    return apiHelpers.apiCall({ 
      url: '/webapi/api/admin/Authenticate', 
      method: 'PUT',
      data,
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<string>
      }] 
    })
  },
  createPassword(data:AloForgottenPass): AxiosPromise<AlrContainer<string>>  {
    return apiHelpers.apiCall({ 
      url: '/webapi/api/admin/Authenticate/forgotten', 
      method: 'PUT',
      data,
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<string>
      }] 
    })
  }
}